import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import qs from 'qs';
import SignupModal from './SignupModal';
import { triggerSignMeUpAnalytics } from '../../app/analytics/analytics.listener';

import styles from './email-signup.scss';

class FooterBanner extends PureComponent {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const query = qs.parse(window.location.search);
    const { signup } = query;
    if (signup === 'true') {
      this.setState({ showModal: true });
    }
  }

  openModal() {
    triggerSignMeUpAnalytics();
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  render() {
    const { title, message, action, className, ...props } = this.props;

    return (
      <div {...props} className={[styles['footer-banner'], className].join(' ')}>
        <div className={styles.content}>
          {title && <h2 className={styles.title}>{title}</h2>}

          {message && <p className={styles.message}>{message}</p>}

          <PrimaryButton className={styles.button} onClick={this.openModal}>
            {action}
          </PrimaryButton>

          {this.state.showModal && <SignupModal onClose={this.closeModal} />}
        </div>
      </div>
    );
  }
}

FooterBanner.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  className: PropTypes.string,
};

FooterBanner.defaultProps = {
  className: '',
};

export default FooterBanner;
